<template>
  <v-tooltip
    :open-delay="tooltipDelay"
    :left="tooltipLeft"
    :right="tooltipRight"
    :top="tooltipTop"
    :bottom="tooltipBottom"
    >
    <template v-slot:activator="{ on }">
      <span class="mx-1" v-on="on" v-if="enableToolTip">
        <v-btn
          style="background-color: transparent !important;"
          class="zoom-hover"
          v-bind="computedProps"
          v-on="computedListeners"
          :elevation="0"
          :loading="loading"
          :min-width="minWidth"
          :width="minWidth"
          :disabled="disabled"
          :text="text"
          :x-small="xsmall"
          :small="small"
          :large="large"
          :x-large="xlarge"
        >
          <slot></slot>
        </v-btn>
      </span>
      <v-btn
        v-else
        style="background-color: transparent !important;"
        class="zoom-hover mx-1"
        v-bind="computedProps"
        v-on="computedListeners"
        :elevation="0"
        :loading="loading"
        :min-width="minWidth"
        :width="minWidth"
        :disabled="disabled"
        :text="text"
        :x-small="xsmall"
        :small="small"
        :large="large"
        :x-large="xlarge"
      >
        <slot></slot>
      </v-btn>
    </template>
    <span v-html="tooltipText"></span>
  </v-tooltip>
</template>
<script>
/**
 * @file DDv2用標準ボタン
 * @namespace components
 */

/**
 * @vue-event {Object} click
 * @see https://vuetifyjs.com/ja/api/v-btn/
 * @example
<dd-transparent-button
  [atmark]click="DdTransparentButtonOnClick">
  検索
</dd-transparent-button>
 */
export default {
  name: 'DdTransparentButton',

  // プロパティ定義
  props: {
    minWidth: {
      type: Number,
      default: 80
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    /**
     * ボタンサイズ
     */
    xsmall: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    xlarge: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipDelay: {
      type: Number,
      default: 1000
    }
  },
  data: () => ({
  }),
  computed: {
    computedProps () {
      return {
        ...this.$props,
        dense: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    }
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>
<style scoped>
i::before {
  color: darkslategray !important;
}
</style>
